import React from "react";
import { BuildNode, NodeStates, StateManager } from "../build/types";
import { InteractionStates } from "../hooks/useInteractionStates";

export const getCompoundStyle = (config: {
    node?: BuildNode;
    isContainer?: boolean;
    otherStyle?: React.CSSProperties;
    skipNode?: boolean;
    stateStyle?: React.CSSProperties;
}): React.CSSProperties => {
    const { node, isContainer, otherStyle, skipNode, stateStyle } = config;
    return {
        ...(node
            ? {
                  ...(!skipNode && node.attr?.style ? node.attr.style : {}),
                  ...(node.customCSS ? node.customCSS : {})
              }
            : {}),
        ...(otherStyle ? otherStyle : {}),
        ...(isContainer ? { outline: "1px solid #d9d1e0" } : {}),
        ...(stateStyle ? stateStyle : {})
    };
};

export const limitCharacters = (str: string, limit?: number, addThreeDots?: boolean): string => {
    if (limit) {
        if (str.length > limit) {
            return str.slice(0, limit) + (addThreeDots ? "..." : "");
        }
    }
    return str;
};

export const isCSSProperties = (value: unknown): value is React.CSSProperties => {
    if (value && typeof value !== "string") {
        if (!Array.isArray(value)) {
            return true;
        }
    }
    return false;
};

export const isColorsArray = (value: unknown): value is string[] => {
    if (value) {
        if (Array.isArray(value)) {
            return true;
        }
    }
    return false;
};

//States for builder

export const getStateStringForBuilder = (stateManager?: StateManager, state?: NodeStates, path?: string): string | undefined => {
    if (stateManager && state && path) {
        const currentState = stateManager[state];
        if (currentState && typeof currentState[path] === "string") {
            return currentState[path] as string;
        }
    }
};

export const getStateStyleForBuilder = (
    stateManager?: StateManager,
    state?: NodeStates,
    path?: string
): React.CSSProperties | undefined => {
    if (stateManager && state && path) {
        const currentState = stateManager[state];
        if (currentState && isCSSProperties(currentState[path])) {
            return currentState[path] as React.CSSProperties;
        }
    }
};

export const getStateColorsForBuilder = (
    stateManager?: StateManager,
    state?: NodeStates,
    path?: string
): string[] | undefined => {
    if (stateManager && state && path) {
        const currentState = stateManager[state];
        if (currentState && isColorsArray(currentState[path])) {
            return currentState[path] as string[];
        }
    }
};

//States for render

export const getStylesFromInteractiveStates = (config: {
    states: InteractionStates;
    defaultStyle?: React.CSSProperties;
    stateManager?: StateManager;
    paths: string[];
    extraStates?: NodeStates[];
}): React.CSSProperties => {
    const { states: originalStates, defaultStyle, stateManager, paths, extraStates } = config;
    let style: React.CSSProperties = { ...defaultStyle };

    const states = { ...originalStates };

    extraStates?.forEach(state => {
        states[state] = true;
    });

    if (stateManager && states) {
        Object.entries(states).forEach(([state, check]) => {
            if (check) {
                paths.forEach(path => {
                    const stateStyle = stateManager[state as NodeStates]?.[path];
                    if (stateStyle && isCSSProperties(stateStyle)) {
                        style = { ...style, ...stateStyle };
                    }
                });
            }
        });
    }

    return style;
};

export const getColorsFromInteractiveStates = (config: {
    states: InteractionStates;
    stateManager?: StateManager;
    defaultColors?: string[];
    paths: string[];
    extraStates?: NodeStates[];
}): string[] | undefined => {
    const { states: originalStates, stateManager, defaultColors, paths, extraStates } = config;
    let colors = defaultColors;

    const states = { ...originalStates };

    extraStates?.forEach(state => {
        states[state] = true;
    });

    if (states && stateManager) {
        Object.entries(states).forEach(([state, check]) => {
            if (check) {
                paths.forEach(path => {
                    const stateColors = stateManager[state as NodeStates]?.[path];
                    if (stateColors && isColorsArray(stateColors)) {
                        colors = stateColors;
                    }
                });
            }
        });
    }

    if (colors) return colors;
};

export const getStyleStringFromInteractiveState = (config: {
    states: InteractionStates;
    stateManager?: StateManager;
    path: string;
    extraStates?: NodeStates[];
}): string | undefined => {
    const { states: originalStates, stateManager, path, extraStates } = config;
    let styleString = null;

    const states = { ...originalStates };

    extraStates?.forEach(state => {
        states[state] = true;
    });

    if (stateManager) {
        Object.entries(states).forEach(([state, check]) => {
            if (check) {
                const stateString = stateManager[state as NodeStates]?.[path];
                if (stateString && typeof stateString === "string") {
                    styleString = stateString;
                }
            }
        });
    }

    if (styleString) return styleString;
};



